// @ts-nocheck
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { IconComponent } from '@lbca-shared/icon';

@Component({
  selector: 'lbca-message-feedback',
  templateUrl: './message-feedback.component.html',
  styleUrl: './message-feedback.component.scss',
  imports: [IconComponent],
  encapsulation: ViewEncapsulation.None,
})
export class MessageFeedbackComponent {
  public showGenericMessage = false;

  public emote: string = '';
  public type: 'success' | 'danger' | 'warning' = 'danger';

  public timeOut: any = null;

  private autoclose: boolean = true;
  public timeout: number = 8000;

  @Input()
  set show(ishow) {
    if (ishow) {
      setTimeout(() => {
        this.showFeedMessage();
      }, 10);
    }
  }

  @Input('autoclose')
  set autocloseSetter(autoclose) {
    this.autoclose = autoclose;
  }

  @Input()
  set emoji(attr) {
    this.emote = attr;
  }

  @Input('type')
  set typeOfFeed(attr) {
    this.type = attr;
  }

  @Output('closeFeed')
  closeFeedEmmiter = new EventEmitter();

  public showFeedMessage(): void {
    this.closeFeedMessage();
    clearTimeout(this.timeOut);
    setTimeout(() => (this.showGenericMessage = true), 100);
    if (this.autoclose) this.timeOut = setTimeout(() => this.closeFeedMessage(), this.timeout);
  }

  public closeFeedMessage(): void {
    this.showGenericMessage = false;
    this.closeFeedEmmiter.emit();
  }

  public getMenuSize() {
    if (document.getElementById('topnav-component')) {
      return document?.getElementById('topnav-component')?.getBoundingClientRect().width + 'px';
    } else {
      return '0px';
    }
  }
}
